/**
 * Flow strip step order (Voluum panel parity) per destination + transition mode.
 * For Media Devoted | Created By Ciro Autiero
 *
 * One Voluum hop between Ad and the rest — matches panel (never duplicate Voluum
 * before Offer). HTML modes insert Meta step(s) where Voluum shows extra hops.
 */

import type { VoluumOfferRedirectMode } from '@trafficpulse/shared';

import type { PathDestinationMode } from '../path-settings.constants';

export type PathFlowSegment =
  | { kind: 'ad' }
  | { kind: 'voluum' }
  | { kind: 'lander' }
  | { kind: 'meta' }
  | { kind: 'offer' };

function transitionTailSegments(
  mode: VoluumOfferRedirectMode,
): PathFlowSegment[] {
  if (mode === 'DOUBLE_HTML') {
    return [{ kind: 'meta' }, { kind: 'meta' }, { kind: 'offer' }];
  }
  if (mode === 'HTML') {
    return [{ kind: 'meta' }, { kind: 'offer' }];
  }
  return [{ kind: 'offer' }];
}

export function getPathTransitionFlowSegments(
  mode: VoluumOfferRedirectMode,
  destination: PathDestinationMode,
): PathFlowSegment[] {
  const head: PathFlowSegment[] = [{ kind: 'ad' }, { kind: 'voluum' }];
  if (destination === 'OFFERS_ONLY') {
    return [...head, ...transitionTailSegments(mode)];
  }
  return [...head, { kind: 'lander' }, ...transitionTailSegments(mode)];
}

const LABEL: Record<PathFlowSegment['kind'], string> = {
  ad: 'Ad',
  voluum: 'Voluum',
  lander: 'Lander',
  meta: 'Meta refresh',
  offer: 'Offer',
};

export function pathFlowSegmentLabels(segments: PathFlowSegment[]): string[] {
  return segments.map((s) => LABEL[s.kind]);
}
